import React, { useState } from "react";
import TableSearchBar from "../TableSearchBar";
import { DatePicker, Button, Select, Tooltip, Radio } from "components/ui";
import { GrPowerReset } from "react-icons/gr";
import { ACTIVE_INACTIVE_STATUS, GENDER_OPTIONS, TAG_OPTIONS } from "constants/app.constant";
import { FaBroadcastTower, FaFilter } from "react-icons/fa";
import { motion } from "framer-motion";
import DatePickerRange from "components/ui/DatePicker/DatePickerRange";
import { debounce } from "lodash";
import { APP_APIS } from "constants/api.constant";
import { getApi } from "services/CommonService";
import AsyncSelect from "react-select/async";

const FilterBar = ({
  search,
  FilterMenu,
  setSearch,
  setFilterValue,
  filterValue,
  placeholder,
  rangeData,
  setIsOpen,
  isOpen,
  showMoreFilters,
  showDropdownBtn = false,
  totalCount,
  broadcastingValue,
  setBroadcastingValue,
}) => {
  const [open, setOpen] = useState(false);

  const loadTagOptions = (inputValue, resolve) => {
    getApi(APP_APIS.TAGS, { search: inputValue }).then((result) => {
      resolve(result?.data?.data || []);
    });
  };
  const loadTags = debounce(loadTagOptions, 300);

  return (
    <div className="flex  w-full items-center gap-4 ">
      {showDropdownBtn && (
        <div className="relative">
          <Tooltip title="Broadcast" placement="top">
            <Button
              variant="solid"
              size="sm"
              onClick={() => setOpen(!open)}
              icon={<FaBroadcastTower />}
            />
          </Tooltip>

          {open && (
            <motion.div
              key="animated-box"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{
                duration: 0.3,
                ease: "easeInOut",
              }}
              className="absolute mt-6 p-4 top-0 z-30  -left-4 "
            >
              <div className="flex flex-col gap-4 bg-white rounded-md  shadow-lg w-[200px] p-4 ">
                <div className="flex items-center">
                  <div class="custom-radio">
                    <input
                      id="radio-1"
                      type="radio"
                      name="1"
                      value="1"
                      checked={broadcastingValue == 1 ? true : false}
                      onChange={(e) => setBroadcastingValue(e.target.name)}
                    />
                    <div class="radio-design"></div>
                  </div>
                  <label
                    htmlFor="radio-1"
                    className="flex items-center gap-2"
                  >{`Select all candidates for broadcasting :${totalCount}`}</label>
                </div>
                <div className="flex items-center">
                  <div class="custom-radio">
                    <input
                      id="radio-2"
                      type="radio"
                      name="2"
                      value="2"
                      checked={broadcastingValue == 2 ? true : false}
                      onChange={(e) => setBroadcastingValue(e.target.name)}
                    />
                    <div class="radio-design"></div>
                  </div>
                  <label className="flex items-center gap-2" htmlFor="radio-2">
                    {" "}
                    Select candidates mannually for broadcasting
                  </label>
                </div>
                <div className="flex items-center">
                  <div class="custom-radio">
                    <input
                      id="radio-3"
                      type="radio"
                      name="3"
                      value="3"
                      checked={broadcastingValue == 3 ? true : false}
                      onChange={(e) => setBroadcastingValue(e.target.name)}
                    />
                    <div class="radio-design"></div>
                  </div>
                  <label className="flex items-center gap-2" htmlFor="radio-3">
                    {" "}
                    Upload file for broadcasting
                  </label>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}
      <div className="grid  lg:grid-cols-5 grid-cols-3  w-full  gap-2 ">
        {FilterMenu?.isSearch && (
          <div  className="col-span-2">
            <TableSearchBar
              search={search}
              placeholder={placeholder}
              onChange={(query) => setSearch(query)}
              SearchBarInfo={FilterMenu?.isSearch?.toolTipText}
            />
          </div>
        )}

        {"gender" in filterValue && (
          <div>
            <Select
              autoComplete="off"
              placeholder={"Select Gender"}
              isMulti={false}
              defaultOptions
              cacheOptions
              size="xs"
              value={filterValue?.gender}
              options={GENDER_OPTIONS}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(selectedOption) => {
                setFilterValue({
                  ...filterValue,
                  gender: selectedOption,
                });
              }}
            />
          </div>
        )}
        {"status" in filterValue && (
          <div>
            <Select
              autoComplete="off"
              placeholder={"Select Status"}
              isMulti={false}
              defaultOptions
              cacheOptions
              size="xs"
              value={filterValue?.status}
              options={ACTIVE_INACTIVE_STATUS}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(selectedOption) => {
                setFilterValue({
                  ...filterValue,
                  status: selectedOption,
                });
              }}
            />
          </div>
        )}
        {"tag" in filterValue && (
          <div>
            <Select
              autoComplete="off"
              placeholder={"Filter By Tag"}
              isMulti={false}
              defaultOptions
              cacheOptions
              size="xs"
              componentAs={AsyncSelect}
              value={filterValue?.tag}
              loadOptions={loadTags}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.value}
              onChange={(selectedOption) => {
                setFilterValue({
                  ...filterValue,
                  tag: selectedOption,
                });
              }}
            />
          </div>
        )}

        {"dateRange" in filterValue && (
          <div>
            <DatePickerRange
              size="sm"
              dateViewCount={2}
              value={filterValue?.dateRange}
              placeholder={FilterMenu?.isCalendarFilter?.placeholder}
              inputFormat="DD MMMM YYYY"
              onChange={(dateArray) => {
                setFilterValue({
                  ...filterValue,
                  dateRange:
                    dateArray[0] && !dateArray[1]
                      ? [dateArray[0], dateArray[0]]
                      : dateArray,
                });
              }}
            />
          </div>
        )}

        <div>
          {FilterMenu?.isResetButton && (
            <Button
              variant="solid"
              size="sm"
              onClick={() => {
                let obj = {};

                Object.keys(filterValue).forEach((item) => {
                  obj[item] = FilterMenu?.isResetButton?.filterKey[item];
                });

                // obj.dateRange = [];
                setFilterValue(obj);
                setSearch("");
              }}
              icon={<GrPowerReset />}
            >
              Reset
            </Button>
          )}
        </div>
      </div>
      {/* {"filter" in filterValue && ( */}
      {showMoreFilters && (
        <div className="flex relative flex-col items-center w-[60px] ">
          <Tooltip title="More Filters">
            <FaFilter
              className="text-2xl text-[#182233] cursor-pointer"
              onClick={() => setIsOpen(!isOpen)}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
export default FilterBar;
